import React, { useState } from "react";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { updateMessageFeedback } from "@/lib/serverComm";
import { Button } from "@/components/ui/button";

const Feedback: React.FC<{
  messageId: number;
  currentFeedback: number | undefined;
}> = ({ messageId, currentFeedback }) => {
  const [feedback, setFeedback] = useState(currentFeedback); // 0: default, 1: thumbs up, -1: thumbs down
  const handleFeedbackChange = async (newFeedback: number) => {
    if (feedback === newFeedback) {
      newFeedback = 0; // Deselect if the same button is clicked
    }

    setFeedback(newFeedback); // Update state immediately for responsiveness

    try {
      // Make API call to update feedback in the database
      await updateMessageFeedback(messageId, newFeedback);
    } catch (error) {
      console.error("Failed to update feedback:", error);
    }
  };

  return (
    <div className="flex justify-end">
      <Button
        onClick={() => handleFeedbackChange(1)}
        className="hover:bg-transparent dark:hover:bg-transparent bg-transparent pr-2"
      >
        <ThumbsUp
          className="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 transition-colors"
          fill={feedback === 1 ? "currentColor" : "none"}
        />
      </Button>

      <Button
        onClick={() => handleFeedbackChange(-1)}
        className="hover:bg-transparent dark:hover:bg-transparent bg-transparent pl-2"
      >
        <ThumbsDown
          className="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 transition-colors"
          fill={feedback === -1 ? "currentColor" : "none"}
        />
      </Button>
    </div>
  );
};

export default Feedback;
